(function () {
  "use strict";

  var PROTECTION_VARIANT_ID = 59034518257996;
  var LEGACY_APP_VARIANT_IDS = [58653655433548, 58637356761420];
  var PREFERENCE_ATTRIBUTE = "shipping_protection__";
  var nativeFetch = window.fetch.bind(window);
  var requestInFlight = null;
  var currentCart = null;
  var checkoutInProgress = false;
  var checkoutBypass = false;
  var preferenceUpdateFailed = false;
  var renderTimers = [];
  var boundRoots = [];
  var cartFetchTimer = null;
  var presentationRepairTimer = null;

  function isLegacyAppVariant(variantId) {
    return LEGACY_APP_VARIANT_IDS.indexOf(Number(variantId)) !== -1;
  }

  function isProtectionVariant(variantId) {
    return Number(variantId) === PROTECTION_VARIANT_ID || isLegacyAppVariant(variantId);
  }

  function cartLineUpdateKey(item) {
    return item && item.key ? item.key : String(item.variant_id);
  }

  function cartRootUrl() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/";
  }

  function cartRequest(url, options) {
    options = options || {};
    var controller = typeof AbortController !== "undefined" ? new AbortController() : null;
    var timeout = controller ? setTimeout(function () { controller.abort(); }, 12000) : null;
    if (controller) options.signal = controller.signal;
    return nativeFetch(url, options).then(function (response) {
      if (!response.ok) throw new Error("Cart request failed: " + response.status);
      return response.json();
    }).finally(function () {
      if (timeout !== null) clearTimeout(timeout);
    });
  }

  function getCartRoots() {
    var roots = [document];

    document.querySelectorAll("upcart-cart-drawer, cart-drawer, cart-notification, [data-cart-drawer]").forEach(function (element) {
      if (element.shadowRoot && roots.indexOf(element.shadowRoot) === -1) roots.push(element.shadowRoot);
    });

    return roots;
  }

  function forEachCartElement(selector, callback) {
    getCartRoots().forEach(function (root) {
      root.querySelectorAll(selector).forEach(callback);
    });
  }

  function getState(cart) {
    var protectionItem = null;
    var legacyProtectionItems = [];
    var protectionLineTotal = 0;
    var regularItemCount = 0;

    (cart.items || []).forEach(function (item) {
      if (Number(item.variant_id) === PROTECTION_VARIANT_ID) {
        protectionItem = item;
        protectionLineTotal += Number(item.final_line_price) || 0;
      } else if (isLegacyAppVariant(item.variant_id)) {
        legacyProtectionItems.push(item);
        protectionLineTotal += Number(item.final_line_price) || 0;
      } else {
        regularItemCount += Number(item.quantity) || 0;
      }
    });

    var preference = cart.attributes && cart.attributes[PREFERENCE_ATTRIBUTE];

    return {
      preference: preference,
      protectionItem: protectionItem,
      legacyProtectionItems: legacyProtectionItems,
      protectionLineTotal: protectionLineTotal,
      regularItemCount: regularItemCount,
      shouldProtect: regularItemCount > 0 && preference !== "off"
    };
  }

  function formatMoney(cents) {
    // The theme formatter uses shop.money_format (SEK), even in USD/EUR carts.
    // Cart API amounts already use the market's presentment currency.
    var locale = window.Shopify && Shopify.locale ? Shopify.locale : document.documentElement && document.documentElement.lang || "sv-SE";
    var currency = currentCart && currentCart.currency || window.Shopify && Shopify.currency && Shopify.currency.active || "SEK";
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(Number(cents || 0) / 100);
  }

  function getProtectionConfig() {
    var config = { price: 0, available: false };
    forEachCartElement("[data-protection-price]", function (element) {
      var value = element.getAttribute("data-protection-price");
      if (value !== null && value !== "" && Number.isFinite(Number(value))) {
        config.price = Number(value);
        config.available = element.getAttribute("data-protection-available") === "true";
      }
    });
    return config;
  }

  function setLoading(isLoading) {
    isLoading = isLoading || checkoutInProgress;
    forEachCartElement("[data-shipping-protection]", function (widget) {
      widget.classList.toggle("is-loading", isLoading);
      var toggle = widget.querySelector("[data-shipping-protection-toggle]");
      if (toggle) toggle.disabled = isLoading;
    });

    forEachCartElement("button[name='checkout']", function (button) {
      if (isLoading && !button.disabled) {
        button.setAttribute("data-protection-loading", "true");
        button.disabled = true;
      } else if (!isLoading && button.hasAttribute("data-protection-loading")) {
        button.removeAttribute("data-protection-loading");
        button.disabled = false;
      }
    });
  }

  function showError(errorKey) {
    forEachCartElement("[data-shipping-protection-error]", function (element) {
      if (!errorKey && !getProtectionConfig().available && currentCart && getState(currentCart).shouldProtect) errorKey = "unavailable";
      var message = errorKey ? element.getAttribute("data-error-" + errorKey) : "";
      element.hidden = !message;
      element.textContent = message || "";
    });
  }

  function updateWidgets(isActive) {
    forEachCartElement("[data-shipping-protection]", function (widget) {
      widget.classList.toggle("is-active", isActive);
      var toggle = widget.querySelector("[data-shipping-protection-toggle]");
      var knob = widget.querySelector(".shipping-protection__toggle-knob");
      var activeColor = widget.getAttribute("data-active-color") || "#6bce6a";
      var inactiveColor = widget.getAttribute("data-inactive-color") || "#848484";

      if (toggle) {
        toggle.setAttribute("aria-checked", isActive ? "true" : "false");
        toggle.style.backgroundColor = isActive ? activeColor : inactiveColor;
      }

      if (knob) knob.style.transform = isActive ? "translateX(18px)" : "translateX(0)";
    });
  }

  function dedupeWidgets() {
    getCartRoots().forEach(function (root) {
      var widgets = Array.prototype.slice.call(root.querySelectorAll("[data-shipping-protection]"));

      if (widgets.length > 1) {
        widgets.slice(0, -1).forEach(function (widget) {
          widget.remove();
        });
      }
    });
  }

  function updateVisibleCartCount(cart) {
    var state = getState(cart);

    forEachCartElement(".cart-count", function (label) {
      var count = state.regularItemCount;
      var cartLink = label.parentElement && label.parentElement.querySelector(".cart-link__bubble");
      label.textContent = count <= 99 ? count : "99+";
      label.classList.toggle("hidden-count", count <= 0);
      if (cartLink) cartLink.classList.toggle("cart-link__bubble--visible", count > 0);
    });
  }

  function getVisibleTotal(cart) {
    var state = getState(cart);
    var total = Number(cart.total_price) || 0;
    var protection = getProtectionConfig();
    return total - state.protectionLineTotal + (state.shouldProtect && protection.available ? protection.price : 0);
  }

  function updateVisibleTotal(cart) {
    var formattedTotal = formatMoney(getVisibleTotal(cart));

    forEachCartElement(".shipping-protection-checkout-total .money", function (element) {
      if (element.textContent !== formattedTotal) element.textContent = formattedTotal;
    });
  }

  function stabilizeProductImages(cart) {
    getCartRoots().forEach(function (root) {
      root.querySelectorAll(".cart-item[data-line]").forEach(function (row) {
        var lineIndex = Number(row.getAttribute("data-line")) - 1;
        var lineItem = cart.items && cart.items[lineIndex];

        if (!lineItem || isProtectionVariant(lineItem.variant_id)) return;

        var image = row.querySelector("img.product--image");
        if (!image) return;

        var source = image.getAttribute("src") || image.getAttribute("data-src");
        if (source && !image.getAttribute("src")) image.setAttribute("src", source);
        var wrapper = image.closest && image.closest(".media-wrapper");
        if (wrapper && source) {
          var escapedSource = source.replace(/["\\]/g, "\\$&");
          wrapper.style.setProperty("background-image", "url(\"" + escapedSource + "\")", "important");
          wrapper.style.setProperty("background-position", "center", "important");
          wrapper.style.setProperty("background-repeat", "no-repeat", "important");
          wrapper.style.setProperty("background-size", "contain", "important");
        }
        image.classList.remove("lazyload", "lazyloading");
        image.classList.add("lazyloaded");
        image.style.setProperty("background-color", "transparent", "important");
        image.style.setProperty("display", "block", "important");
        image.style.setProperty("opacity", "1", "important");
        image.style.setProperty("visibility", "visible", "important");
        image.style.setProperty("object-fit", "contain");
      });
    });
  }

  function stabilizeProductPrices(cart) {
    getCartRoots().forEach(function (root) {
      root.querySelectorAll(".cart-item[data-line]").forEach(function (row) {
        var lineIndex = Number(row.getAttribute("data-line")) - 1;
        var lineItem = cart.items && cart.items[lineIndex];

        if (!lineItem) return;

        if (isProtectionVariant(lineItem.variant_id)) {
          row.hidden = true;
          row.setAttribute("aria-hidden", "true");
          row.setAttribute("data-shipping-protection-cart-line", "");
          row.style.setProperty("display", "none", "important");
          return;
        }

        var price = row.querySelector(".cart__price:not(.cart__price--compare)");
        var money = price && (price.querySelector(".money") || price);
        if (money) money.textContent = formatMoney(lineItem.final_line_price);
      });
    });
  }

  function renderCartState(cart) {
    if (!cart) return;
    currentCart = cart;
    dedupeWidgets();
    updateWidgets(getState(cart).shouldProtect);
    updateVisibleCartCount(cart);
    updateVisibleTotal(cart);
    stabilizeProductPrices(cart);
    stabilizeProductImages(cart);
    bindAllRoots();
  }

  function schedulePresentationRepair() {
    if (!currentCart || checkoutInProgress || presentationRepairTimer) return;

    presentationRepairTimer = true;
    setTimeout(function () {
      presentationRepairTimer = null;
      updateVisibleTotal(currentCart);
      stabilizeProductPrices(currentCart);
      stabilizeProductImages(currentCart);
    }, 0);
  }

  function scheduleCartRender(cart) {
    if (!cart) return;

    renderTimers.forEach(function (timer) {
      clearTimeout(timer);
    });

    renderTimers = [0, 60, 220, 700, 1400].map(function (delay) {
      return setTimeout(function () {
        renderCartState(cart);
      }, delay);
    });
  }

  function postCartUpdate(body) {
    return cartRequest(cartRootUrl() + "cart/update.js", {
      method: "POST",
      headers: { "Accept": "application/json", "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });
  }

  function setPreference(preference, cart) {
    if (requestInFlight) return requestInFlight;

    var state = getState(cart || currentCart || { items: [], attributes: {} });
    var body = { attributes: {} };
    body.attributes[PREFERENCE_ATTRIBUTE] = preference;

    if (state.protectionItem || state.legacyProtectionItems.length) {
      body.updates = {};
      if (state.protectionItem) {
        body.updates[cartLineUpdateKey(state.protectionItem)] = 0;
      }
      state.legacyProtectionItems.forEach(function (item) {
        body.updates[cartLineUpdateKey(item)] = 0;
      });
    }

    setLoading(true);
    preferenceUpdateFailed = false;
    showError("");

    requestInFlight = postCartUpdate(body).then(function (updatedCart) {
      if (window.theme) theme.cart = updatedCart;
      scheduleCartRender(updatedCart);
      showError("");
      return updatedCart;
    }).catch(function () {
      preferenceUpdateFailed = true;
      showError("update");
      if (currentCart) scheduleCartRender(currentCart);
      return currentCart;
    }).finally(function () {
      requestInFlight = null;
      setLoading(false);
    });

    return requestInFlight;
  }

  function reconcile(cart) {
    if (!cart) return;
    currentCart = cart;
    scheduleCartRender(cart);
    if (requestInFlight || checkoutInProgress) return;

    var state = getState(cart);

    if (state.regularItemCount === 0 && (state.protectionItem || state.legacyProtectionItems.length || state.preference === "off")) {
      setPreference("on", cart);
    } else if (state.protectionItem || state.legacyProtectionItems.length) {
      setPreference(state.preference === "off" ? "off" : "on", cart);
    }
  }

  function fetchCartAndReconcile() {
    return cartRequest(cartRootUrl() + "cart.js", { headers: { "Accept": "application/json" } }).then(function (cart) {
      reconcile(cart);
      return cart;
    }).catch(function () {
      showError("load");
    });
  }

  function scheduleCartFetch() {
    clearTimeout(cartFetchTimer);
    cartFetchTimer = setTimeout(fetchCartAndReconcile, 40);
  }

  function handleToggle(toggle, event) {
    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    if (!toggle || requestInFlight || checkoutInProgress) return;
    var isActive = toggle.getAttribute("aria-checked") === "true";
    updateWidgets(!isActive);
    setPreference(isActive ? "off" : "on", currentCart);
  }

  function continueToCheckout(control) {
    checkoutBypass = true;
    setLoading(false);
    window.location.assign(cartRootUrl() + "checkout");
  }

  function handleCheckout(control, event) {
    if (checkoutBypass) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutInProgress) return;

    checkoutInProgress = true;
    setLoading(true);
    showError("");

    Promise.resolve(requestInFlight).catch(function () {
      return null;
    }).then(function () {
      if (preferenceUpdateFailed) {
        var preferenceError = new Error("Protection preference update failed");
        preferenceError.protectionPreference = true;
        throw preferenceError;
      }
      // A shopper can check out before the ATC redraw finishes. Re-read the
      // server cart so a stale/empty snapshot cannot silently drop protection.
      return cartRequest(cartRootUrl() + "cart.js", { headers: { "Accept": "application/json" } });
    }).then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) throw new Error("Cart fetch failed");
      var state = getState(cart);
      if (state.shouldProtect && !getProtectionConfig().available) {
        var unavailableError = new Error("Protection variant unavailable");
        unavailableError.protectionUnavailable = true;
        throw unavailableError;
      }
      var body = { updates: {}, attributes: {} };
      if (state.shouldProtect) {
        body.updates[state.protectionItem ? cartLineUpdateKey(state.protectionItem) : String(PROTECTION_VARIANT_ID)] = 1;
      } else if (state.protectionItem) {
        body.updates[cartLineUpdateKey(state.protectionItem)] = 0;
      }
      state.legacyProtectionItems.forEach(function (item) {
        body.updates[cartLineUpdateKey(item)] = 0;
      });
      body.attributes[PREFERENCE_ATTRIBUTE] = state.shouldProtect ? "on" : "off";
      return postCartUpdate(body);
    }).then(function (updatedCart) {
      var state = getState(updatedCart);
      if (!state.regularItemCount) throw new Error("Cart is empty");
      if (state.shouldProtect && (!state.protectionItem || state.protectionItem.quantity !== 1)) throw new Error("Protection was not added correctly");
      if (!state.shouldProtect && state.protectionItem) throw new Error("Opted-out protection was not removed");
      continueToCheckout(control);
    }).catch(function (error) {
      checkoutInProgress = false;
      setLoading(false);
      showError(error && error.protectionPreference ? "update" : error && error.protectionUnavailable ? "unavailable" : "checkout");
    });
  }

  function findInEventPath(event, selector) {
    var eventPath = event.composedPath ? event.composedPath() : [event.target];

    for (var index = 0; index < eventPath.length; index += 1) {
      var element = eventPath[index];
      if (element && element.matches && element.matches(selector)) return element;
    }

    return null;
  }

  function onRootClick(event) {
    var toggle = findInEventPath(event, "[data-shipping-protection-toggle]");
    if (toggle) {
      handleToggle(toggle, event);
      return;
    }

    var checkout = findInEventPath(event, "button[name='checkout'], a[href*='/checkout']");
    if (checkout) handleCheckout(checkout, event);
  }

  function bindRoot(root) {
    if (!root || boundRoots.indexOf(root) !== -1) return;
    boundRoots.push(root);
    root.addEventListener("click", onRootClick, true);
  }

  function bindAllRoots() {
    getCartRoots().forEach(bindRoot);
  }

  function observeExternalCartMutations() {
    var observedFetch = window.fetch.bind(window);

    window.fetch = function () {
      var fetchArguments = arguments;
      var request = fetchArguments[0];
      var url = typeof request === "string" ? request : request && request.url;

      return observedFetch.apply(window, fetchArguments).then(function (response) {
        if (!checkoutInProgress && response.ok && url && /\/cart\/(add|change|update|clear)\.js/.test(url)) {
          scheduleCartFetch();
        }
        return response;
      });
    };
  }

  function observeCartMarkup() {
    var CartMutationObserver = window.MutationObserver || (typeof MutationObserver !== "undefined" ? MutationObserver : null);
    if (!CartMutationObserver || !document.body) return;

    var observer = new CartMutationObserver(function (mutations) {
      if (checkoutInProgress) return;

      var hasNewCartMarkup = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          if (!node || node.nodeType !== 1) return false;
          if (node.matches && node.matches("#ajaxCartForm, .ajaxcart-products, [data-shipping-protection]")) return true;
          return Boolean(node.querySelector && node.querySelector("#ajaxCartForm, .ajaxcart-products, [data-shipping-protection]"));
        });
      });

      if (hasNewCartMarkup) {
        if (currentCart) renderCartState(currentCart);
        scheduleCartFetch();
      }

      var presentationWasOverwritten = mutations.some(function (mutation) {
        var target = mutation.target && mutation.target.nodeType === 1 ? mutation.target : mutation.target && mutation.target.parentElement;
        if (!target || !target.closest) return false;
        return Boolean(target.closest(".shipping-protection-checkout-total, .cart-item[data-line]"));
      });

      if (presentationWasOverwritten) schedulePresentationRepair();
    });

    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  document.addEventListener("dbtfy:cartLoaded", function () {
    if (window.theme && theme.cart) reconcile(theme.cart);
  });

  ["cart:updated", "cart-updated", "cart:refresh", "upcart:cartUpdated"].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleCartFetch);
  });

  if (window.jQuery) {
    window.jQuery(document.body)
      .off("ajaxCart.afterCartLoad.shippingProtection")
      .on("ajaxCart.afterCartLoad.shippingProtection", function (event, cart) {
      reconcile(cart);
    });

    window.jQuery(document)
      .off("ajaxComplete.shippingProtection")
      .on("ajaxComplete.shippingProtection", function (event, xhr, settings) {
        if (!checkoutInProgress && settings && /\/cart\/(add|change|update|clear)\.js/.test(settings.url || "")) {
          scheduleCartFetch();
        }
      });
  }

  bindAllRoots();
  observeExternalCartMutations();
  observeCartMarkup();

  window.addEventListener("pageshow", function (event) {
    if (!event.persisted) return;
    checkoutInProgress = false;
    checkoutBypass = false;
    setLoading(false);
    fetchCartAndReconcile();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fetchCartAndReconcile);
  } else {
    fetchCartAndReconcile();
  }
})();
